module.exports = __webpack_public_path__ + "static/media/card-to-card.19819f06.svg";